import React, { Fragment } from 'react';
import { Container, Row, Card, CardBody, Col, Media } from 'reactstrap';
import DailyEarning from './DailyEarning';
import { NewUsersSvg} from '../../Widgets/SvgIcons';
import Greeting from './Greeting';
import CountUp from 'react-countup';
import NewsUpdates from './NewsUpdate';
import { H4, H6 } from '../../../AbstractElements';
import OutgoingProject from './OutgoingProject';
import RecentActivitys from './RecentActivitys';
import TotalTrasactions from './TotalTrasactions';
import Yearly from './Yearly';

const DefaultContain = () => {
  const val = true;
  return (
    <Fragment>
      <Container fluid={true} className="default-dash">
        <Row>
          <Greeting />
          {/*<Col sm="6" xl="3" lg="6">
              <Card className="o-hidden">
                <CardBody>
                  <Media className="static-widget">
                    <Media body><H6 attrH6={{ className: 'font-roboto' }}>User</H6>
                      <H4 attrH4={{ className: 'mb-0 counter' }}><CountUp end={45631} /></H4>
                    </Media>
                    <NewUsersSvg />
                  </Media>
                  <div className="progress-widget">
                    <div className="progress sm-progress-bar progress-animate">
                      <div className="progress-gradient-primary" role="progressbar" style={{ width: '75%' }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"><span className="animate-circle"></span></div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>}*/}
          <NewsUpdates />
          {/*<DailyEarning />*/}
          {/*
          <OutgoingProject val={val} />
          <RecentActivitys />
          <TotalTrasactions />
          <Yearly />*/}
        </Row>
      </Container>
    </Fragment>
  );
};
export default DefaultContain;
